export interface IContainer {
    get: <T>(key: symbol) => T;
    bind: <T>(key: symbol, val: T) => void;
    remove: (key: symbol) => void;
    importBindings: (container: IContainer) => void;
}

export type ILazyBinder<T> = () => Promise<T>;

/* global container storage */
type ContainerMap = Record<string, IContainer>;

/* eslint-disable no-restricted-globals */
const globalObject: any = typeof window === 'undefined' ? globalThis : window;
/* eslint-enable no-restricted-globals */

export function injectContainer(name = 'default'): IContainer {
    let containers: ContainerMap | undefined = globalObject.containers;
    if (!containers) {
        console.warn('No containers found! Creating new');
        containers = {};
        globalObject.containers = containers;
    }

    const container = containers[name];
    return container;
}

export function bindContainer(container: IContainer, name = 'default') {
    let containers: ContainerMap | undefined = globalObject.containers;
    if (!containers) {
        containers = {};
        globalObject.containers = containers;
    }

    if (containers[name]) {
        console.warn(`Overwriting container: ${name}`);
    }

    containers[name] = container;
}

export function removeContainer(name = 'default') {
    const containers: ContainerMap | undefined = globalObject.containers;

    if (containers) {
        delete containers[name];
    }
}
